import { io } from "socket.io-client";
import { API_BASE_URL } from "../Variables";

let socket;

/**
 * Connect to the socket server
 * @param {*} user_id - The user_id of the user connecting to the socket
 * @returns - The socket object
 */
export const connectSocket = (user_id) => {
  if (!socket) {
    socket = io(API_BASE_URL, {
      transports: ['websocket'],
      withCredentials: true,
      query: { user_id },
    });
  }
  return socket;
};

/**
 * Get the socket object
 * @returns - The socket object
 */
export const getSocket = () => {
  if (!socket) {
    console.warn("Socket has not been initialized.");
  }
  return socket;
};

/**
 * Disconnect from the socket server
 */
export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null; // Ensure the socket is reset
  }
};
